export const SUBMISSION_REQUEST = "submissionReducer/SUBMISSION_REQUEST";
export const SUBMISSION_SUCCESS = "submissionReducer/SUBMISSION_SUCCESS";
export const SUBMISSION_FAILED = "submissionReducer/SUBMISSION_FAILED";
export const SUBMISSION_RESET = "submissionReducer/SUBMISSION_RESET";

export const SUBMISSION_DELETE_REQUEST = "submissionDeleteReducer/SUBMISSION_DELETE_REQUEST";
export const SUBMISSION_DELETE_SUCCESS = "submissionDeleteReducer/SUBMISSION_DELETE_SUCCESS";
export const SUBMISSION_DELETE_FAILED = "submissionDeleteReducer/SUBMISSION_DELETE_FAILED";
export const SUBMISSION_DELETE_RESET = "submissionDeleteReducer/SUBMISSION_DELETE_RESET";

export const SUBMIT_HOMEWORK_REQUEST = "submit_homeworkReducer/SUBMIT_HOMEWORK_REQUEST";
export const SUBMIT_HOMEWORK_SUCCESS = "submit_homeworkReducer/SUBMIT_HOMEWORK_SUCCESS";
export const SUBMIT_HOMEWORK_FAILED = "submit_homeworkReducer/SUBMIT_HOMEWORK_FAILED";
export const SUBMIT_HOMEWORK_RESET = "submit_homeworkReducer/SUBMIT_HOMEWORK_RESET";


